import { Avatar, TableContainer, TableRow } from '@mui/material';
import styled from '@emotion/styled';

export const StyledTableAvatar = styled(Avatar)(({ theme }) => ({
  position: 'static',
  padding: '11px',
  fontWeight: 700,
  fontSize: '15px',
  lineHeight: '1.4',
  letterSpacing: '-0.04em',
  color: theme.palette.black.semiDark,
  backgroundColor: 'rgba(144, 212, 219, 1)',
  boxShadow: '0px 2.2px 13.2px 0px rgba(175, 190, 255, 0.06)',
  boxShadow: '0px 1.1px 2.2px 0px rgba(140, 156, 237, 0.05)',
  transition: 'all 0.4s ease',
}));

export const StyledTableContainer = styled(TableContainer)(
  ({ theme, margintop }) => ({
    overflowX: 'unset',
    marginTop: margintop ? margintop : '40px',
    // paddingInline: paddingInline ? paddingInline : '0',
  }),
);

export const StyledTableHeaderRow = styled(TableRow)(
  ({
    theme,
    lastchildalignment,
    lastchildpaddingstart,
    lastchildwidth,
    thwidth,
  }) => ({
    th: {
      border: 0,
      fontSize: '16px',
      fontWeight: '700',
      color: theme.palette.blue.dark,

      '&:not(:first-of-type)': {
        width: thwidth && thwidth,
      },

      '&:not(:last-child)': {
        width: '125px',
      },

      '&:last-child': {
        textAlign: lastchildalignment,
        paddingInlineStart: lastchildpaddingstart,
        width: lastchildwidth && lastchildwidth,
      },
    },
  }),
);

export const StyledTableBodyRow = styled(TableRow)(
  ({ theme, tdwidth, lastchildpaddingend }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      width: tdwidth && tdwidth,
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      //   div: {
      //     marginInline: 'auto',
      //   },

      '&:not(:last-child)': {
        width: '125px',
      },

      '&:first-of-type': {
        width: '220px',

        div: {
          p: {
            color: theme.palette.black.text,
            fontWeight: '700',
            // width: '64px',
          },
        },
      },

      '&:last-child': {
        paddingInlineEnd: lastchildpaddingend ? lastchildpaddingend : '55px',
        color: theme.palette.blue.text,

        div: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);

export const StyledProfileTableHeaderRow = styled(TableRow)(
  ({
    theme,
    lastchildalignment,
    lastchildpaddingstart,
    lastchildwidth,
    thwidth,
  }) => ({
    th: {
      border: 0,
      fontSize: '16px',
      fontWeight: '700',
      color: theme.palette.blue.dark,

      //   '&:not(:first-of-type)': {
      //     width: thwidth && thwidth,
      //   },

      //   '&:not(:last-child)': {
      //     width: '125px',
      //   },

      //   '&:last-child': {
      // textAlign: lastchildalignment,
      // paddingInlineStart: lastchildpaddingstart,
      // width: lastchildwidth && lastchildwidth,
      //   },
    },
  }),
);

export const StyledProfileTableBodyRow = styled(TableRow)(
  ({ theme, tdwidth, lastchildpaddingend }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      width: tdwidth && tdwidth,
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      //   div: {
      //     marginInline: 'auto',
      //   },

      '&:not(:last-child)': {
        width: '170px',
      },

      '&:first-of-type': {
        width: '130px',
        div: {
          p: {
            color: theme.palette.black.text,
            fontWeight: '700',
            // width: '64px',
          },
        },
      },

      '&:last-child': {
        // paddingInlineEnd: lastchildpaddingend ? lastchildpaddingend : '55px',
        color: theme.palette.blue.text,

        div: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);

export const StyledContractTableHeaderRow = styled(TableRow)(({ theme }) => ({
  th: {
    border: 0,
    fontSize: '16px',
    fontWeight: '700',
    color: theme.palette.blue.dark,
    width: '200px',
  },
}));

export const StyledContractTableBodyRow = styled(TableRow)(({ theme }) => ({
  boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',

  td: {
    border: 0,
    marginInline: 'auto',
    fontSize: '16px',
    color: theme.palette.blue.text,
    fontWeight: '500',
    paddingBlock: '28px',

    div: {
      marginInline: 'auto',
    },

    '&:last-child': {
      div: {
        justifyContent: 'flex-end',
      },
    },
  },
}));

export const StyledTrainingsTableBodyRow = styled(TableRow)(
  ({ theme, isshowalert = '' }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      '&:nth-of-type(1)': {
        width: '18%',
      },
      '&:nth-of-type(2)': {
        width: '15%',
      },
      '&:nth-of-type(3)': {
        width: isshowalert ? '22%' : '15%',
        backgroundColor: isshowalert ? theme.palette.red.semiRed : 'initial',

        div: {
          width: 'fit-content',
          marginInline: isshowalert ? '' : 'auto',

          div: {
            display: isshowalert ? 'flex' : 'none',
            color: theme.palette.red.dark,
            backgroundColor: theme.palette.red.semiOrange,
          },
        },
      },
      '&:nth-of-type(4)': {
        width: '10%',
      },
      '&:nth-of-type(5)': {
        width: '20%',
      },
      '&:nth-of-type(6)': {
        width: '10%',
        div: {
          width: 'fit-content',
          marginInlineStart: 'auto',
        },
      },

      // div: {
      //   marginInline: 'auto',
      // },
      // '&:not(:last-child)': {
      // width: '100%',
      // },
      // '&:first-of-type': {
      //   div: {
      //     p: {
      //       color: theme.palette.black.text,
      //       fontWeight: '700',
      //       width: '64px',
      //     },
      //   },
      // },
      // '&:last-child': {
      //   paddingInlineEnd: '55px',
      //   color: theme.palette.blue.text,
      //   div: {
      //     justifyContent: 'flex-end',
      //   },
      // },
    },
  }),
);

export const StyledCustomerTableHeaderRow = styled(TableRow)(
  ({
    theme,
    lastchildalignment,
    lastchildpaddingstart,
    lastchildwidth,
    thwidth,
  }) => ({
    th: {
      border: 0,
      fontSize: '16px',
      fontWeight: '700',
      color: theme.palette.blue.dark,

      '&:not(:first-of-type)': {
        width: thwidth && thwidth,
      },

      '&:not(:last-child)': {
        width: '170px',
      },

      '&:last-child': {
        textAlign: lastchildalignment,
        paddingInlineStart: lastchildpaddingstart,
        width: lastchildwidth && lastchildwidth,
      },
    },
  }),
);

export const StyledCustomerTableBodyRow = styled(TableRow)(
  ({ theme, tdwidth, lastchildpaddingend }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      width: tdwidth && tdwidth,
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      '&:not(:last-child)': {
        width: '190px',
      },

      '&:first-of-type': {
        // width: '220px',

        div: {
          p: {
            color: theme.palette.black.text,
            fontWeight: '700',
            // width: '64px',
          },
        },
      },

      '&:last-child': {
        paddingInlineEnd: lastchildpaddingend ? lastchildpaddingend : '55px',
        color: theme.palette.blue.text,

        div: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);

export const StyledTableWorkArrangementHeaderRow = styled(TableRow)(
  ({
    theme,
    lastchildalignment,
    lastchildpaddingstart,
    lastchildwidth,
    thwidth,
  }) => ({
    th: {
      border: 0,
      fontSize: '16px',
      fontWeight: '700',
      color: theme.palette.blue.dark,

      //   '&:not(:last-child)': {
      //     width: '170px',
      //   },

      '&:last-child': {
        textAlign: lastchildalignment,
        paddingInlineStart: lastchildpaddingstart,
        width: lastchildwidth && lastchildwidth,
      },
    },
  }),
);

export const StyledWorkArrangementTableBodyRow = styled(TableRow)(
  ({ theme, tdwidth, lastchildpaddingend }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      width: tdwidth && tdwidth,
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      '&:first-of-type': {
        div: {
          p: {
            color: theme.palette.black.text,
            fontWeight: '700',
          },
        },
      },

      '&:last-child': {
        paddingInlineEnd: lastchildpaddingend ? lastchildpaddingend : '55px',
        color: theme.palette.blue.text,

        div: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);

export const StyledAdminTableHeaderRow = styled(TableRow)(
  ({
    theme,
    lastchildalignment,
    lastchildpaddingstart,
    lastchildwidth,
    thwidth,
  }) => ({
    th: {
      border: 0,
      fontSize: '16px',
      fontWeight: '700',
      color: theme.palette.blue.dark,

      '&:not(:first-of-type)': {
        width: thwidth && thwidth,
      },

      '&:not(:last-child)': {
        width: '125px',
      },

      '&:last-child': {
        textAlign: lastchildalignment,
        paddingInlineStart: lastchildpaddingstart,
        width: lastchildwidth && lastchildwidth,
      },
    },
  }),
);

export const StyledAdminTableBodyRow = styled(TableRow)(
  ({ theme, tdwidth, lastchildpaddingend }) => ({
    boxShadow: '0px 8px 24px 0px rgba(141, 175, 189, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',

    td: {
      width: tdwidth && tdwidth,
      border: 0,
      marginInline: 'auto',
      fontSize: '16px',
      color: theme.palette.blue.text,
      fontWeight: '500',

      //   div: {
      //     marginInline: 'auto',
      //   },

      '&:not(:last-child)': {
        width: '135px',
      },

      '&:first-of-type': {
        width: '130px',

        div: {
          p: {
            color: theme.palette.black.text,
            fontWeight: '700',
            // width: '64px',
          },
        },
      },

      '&:last-child': {
        paddingInlineEnd: lastchildpaddingend ? lastchildpaddingend : '55px',
        color: theme.palette.blue.text,

        div: {
          justifyContent: 'flex-end',
        },
      },
    },
  }),
);
